module.exports = __webpack_public_path__ + "img/examplepdf.4f366c85.png";